var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRentWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9EEBE274-98CA-4557-8974-2565512E549A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Summary-Cards",
    transform: "translate(-576.000000, -317.000000)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Property",
    transform: "translate(360.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-rent",
    transform: "translate(216.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,4.9998076 C4,3.89534436 4.89821238,3 6.00001277,3 L21.9999872,3 C23.1045638,3 24,3.89706013 24,4.99841943 L24,15.0015806 C24,16.1052771 23.1018647,17 21.9973969,17 L20,17 L20,19.0015806 C20,20.1052771 19.1017876,21 17.9999872,21 L2.00001277,21 C0.895436216,21 0,20.1029399 0,19.0015806 L0,8.99841943 C0,7.89472286 0.898212381,7 2.00001277,7 L4,7 L4,4.9998076 Z M17.9999872,7 C19.1045638,7 20,7.89706013 20,8.99841943 L20,15 L21.9973969,15 C21.9989991,15 22,4.99841943 22,4.99841943 C22,5.00081767 6.00001277,5 6.00001277,5 C6.00083082,5 6.00064196,6.12676559 6.00037277,7 L17.9999872,7 Z M2,9 L2,19 L18,19 L18,9 L2,9 Z M3,16.5046844 C3,16.2259549 3.22548759,16 3.49538898,16 L5.50461102,16 C5.7782068,16 6,16.2216766 6,16.5046844 L6,17.4953156 C6,17.7740451 5.77451241,18 5.50461102,18 L3.49538898,18 C3.2217932,18 3,17.7783234 3,17.4953156 L3,16.5046844 Z M14,10.5046844 C14,10.2259549 14.2254876,10 14.495389,10 L16.504611,10 C16.7782068,10 17,10.2216766 17,10.5046844 L17,11.4953156 C17,11.7740451 16.7745124,12 16.504611,12 L14.495389,12 C14.2217932,12 14,11.7783234 14,11.4953156 L14,10.5046844 Z M10,17 C8.34314575,17 7,15.6568542 7,14 C7,12.3431458 8.34314575,11 10,11 C11.6568542,11 13,12.3431458 13,14 C13,15.6568542 11.6568542,17 10,17 Z",
    id: "path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentWhite);
export default __webpack_public_path__ + "static/media/rent-white.2c5f8d86f8fc2d78b77501b4ef3e47a4.svg";
export { ForwardRef as ReactComponent };